import React from 'react';
import decodeJwt from "jwt-decode";
import { useRedirect } from 'react-admin';
import { Card, CardContent, Link } from '@material-ui/core';
import { DisclaimerComponent } from '../components/disclaimer.js';
import DashboardChart from './DashboardChart';
import authProvider from '../authProvider';

window.redirectHomePage = true;

export default ({ permissions, ...props }) => {
  if (window.redirectHomePage && permissions?.preferences?.homepage==='carbon') {
    const redirect = useRedirect();
    redirect('/carbon/dashboard');
    window.redirectHomePage = false;
  }
  return (
    <div>
      <Card style={{ width: '100%' }} raised>
        <CardContent>
          <div style={{fontWeight: 'bolder'}}>Main Dashboard<span style={{margin: '0 10px 0 10px'}}>|</span><Link href={'/#/carbon/dashboard'}>Analytics Adapter Dashboard</Link></div>
          <DashboardChart authProvider={authProvider} />
        </CardContent>
      </Card>

      <DisclaimerComponent />
      <a href="https://g.co/bard/share/9b5e3f704d95" style={{ fontFamily: 'Roboto, Helvetica, Arial, sans-serif,', color:'white', fontSize:'small', float: 'right'}} target='_blank'>Why do we use Dark mode?</a>

    </div>
  )
};